export const NAV = {
  logo: "nav-logo",
  home: "nav-home",
  moodCheckin: "nav-mood-checkin",
  journal: "nav-journal",
  library: "nav-library",
  readingList: "nav-reading-list",
  timeline: "nav-timeline",
  community: "nav-community",
  settings: "nav-settings",
  logout: "nav-logout",
};

export const LANDING = {
  getStarted: "landing-get-started",
  signIn: "landing-sign-in",
  heroCta: "landing-hero-cta",
};

export const AUTH = {
  loginEmail: "login-email",
  loginPassword: "login-password",
  loginSubmit: "login-submit",
  loginError: "login-error",
  signupName: "signup-name",
  signupEmail: "signup-email",
  signupPassword: "signup-password",
  signupSubmit: "signup-submit",
  signupError: "signup-error",
  switchToSignup: "switch-to-signup",
  switchToLogin: "switch-to-login",
};

export const DASH = {
  container: "dashboard-container",
  greeting: "dashboard-greeting",
  moodCta: "dashboard-mood-cta",
  journalCta: "dashboard-journal-cta",
  libraryCta: "dashboard-library-cta",
  timelineCta: "dashboard-timeline-cta",
};

export const MOOD = {
  container: "mood-checkin-container",
  emotionOption: (id) => `mood-emotion-${id}`,
  intensity: (n) => `mood-intensity-${n}`,
  note: "mood-note",
  submit: "mood-submit",
};

export const JOURNAL = {
  container: "journal-container",
  text: "journal-text",
  submit: "journal-submit",
};

export const REC = {
  container: "recommendations-container",
  loading: "recommendations-loading",
  empathicNote: "recommendations-empathic-note",
  themeChip: (i) => `rec-theme-${i}`,
  card: (i) => `rec-card-${i}`,
  saveBtn: (i) => `rec-save-${i}`,
  laterBtn: (i) => `rec-later-${i}`,
  reviewBtn: (i) => `rec-review-${i}`,
};

export const LIB = {
  container: "library-container",
  item: (id) => `library-item-${id}`,
  statusSelect: (id) => `library-status-${id}`,
  deleteBtn: (id) => `library-delete-${id}`,
  empty: "library-empty",
};

export const READING = {
  container: "reading-list-container",
  item: (id) => `reading-list-item-${id}`,
  statusSelect: (id) => `reading-list-status-${id}`,
  moveToLibrary: (id) => `reading-list-move-${id}`,
  deleteBtn: (id) => `reading-list-delete-${id}`,
  empty: "reading-list-empty",
};

export const TIMELINE = {
  container: "timeline-container",
  chart: "timeline-chart",
  empty: "timeline-empty",
};

export const COMMUNITY = {
  container: "community-container",
  composerOpen: "community-composer-open",
  composerTitle: "community-composer-title",
  composerType: "community-composer-type",
  composerRating: (n) => `community-composer-rating-${n}`,
  composerBody: "community-composer-body",
  composerSubmit: "community-composer-submit",
  review: (id) => `community-review-${id}`,
  helpfulBtn: (id) => `community-helpful-${id}`,
  deleteBtn: (id) => `community-delete-${id}`,
};

export const SETTINGS = {
  container: "settings-container",
  remindersToggle: "settings-reminders-toggle",
};
